// extracted by mini-css-extract-plugin
module.exports = {"root":"SetPasswdForm_root__3W5QU","label":"SetPasswdForm_label__ip39q"};